import BrowseList from './BrowseList';

export default BrowseList;
